import "./Locations.scss";
import Btn from "../../../components/btn/Btn";
import { motion } from "framer-motion";
import { MdAddCall } from "react-icons/md";

const Locations = () => {
  const locationList = [
    {
      id: 0,
      p1: "Emergency Care and Recovery Centre for Women",
      p2: "Thanal ECRC",
      address:
        "No.777, 100 Feet Road, Ring Road, Banashankari 3rd Stage, Hoskarahalli, Bengaluru, 560085",
      phone: "+91 87922 54867",
    },
    {
      id: 1,
      p1: "Emergency Care and Recovery Centre for Men",
      p2: "HBS ECRC",
      address:
        "58, Cock Burn Rd, Sulthangunta, Shivaji Nagar, Bengaluru, Karnataka 560051",
      phone: "+91 89258 16500",
    },
    {
      id: 2,
      p1: "Emergency Care and Recovery Centre for Women and Men",
      p2: "Sir CV Raman ECRC (Manovruksha)",
      address:
        "Sir CV Raman Hospital - 68/1, 4th B Cross, 80 Feet Rd, Michael Palaya, Indiranagar, Bengaluru, Karnataka 560038",
      phone: "+91 86608 42579",
    },
    {
      id: 3,
      p1: "Aaladamara Services – Mysore City Emergency Care and Recovery Centre for Women",
      p2: "Manasa ECRC",
      address:
        "No. 4, Lalithadripura Road, K.C Layout, Opp. Lalitha Mahal Palce Hotel, Mysuru 570011",
      phone: "+91 8277350808",
    },
  ];
  return (
    <section className="location_sec p_b">
      <div className="content_wrap">
        <h2 className="text-center mb-5 mt-4">
          Aaladamara Services- Bangalore City and Mysore
        </h2>
        <div className="location_grid">
          {locationList?.map((data, k) => {
            return (
              <motion.div
                initial={{ translateY: 32, opacity: 0 }}
                whileInView={{ translateY: 0, opacity: 1 }}
                transition={{
                  duration: 0.6,
                  ease: "easeInOut",
                  delay: 0.15 * k,
                }}
                viewport={{ once: true }}
                className="location_card"
                key={data?.id}
              >
                <p>{data?.p1}</p>
                <p>{data?.p2}</p>
                <p>{data?.address}</p>
                <div className="line"></div>
                <div className="contact">
                  <a href={`tel:${data?.phone}`}><MdAddCall /> {data?.phone}</a>
                </div>
                <a href={`tel:${data?.phone}`} className="mt-2">
                  <Btn type="button" title="Contact Us" />
                </a>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
export default Locations;
